module.exports = __webpack_public_path__ + "img/bj.9032c5c0.svg";